// @ts-nocheck
// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_STORE = '/store';
const ROOTS_MOBILE = '/m';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  root: '/',
  pricing: '/pricing',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  TermsOfService: '/TermsOfService',
  PrivacyPolicy : '/PrivacyPolicy',
  page404: '/404',
  page500: '/500'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    analytics: path(ROOTS_DASHBOARD, '/analytics')
  },
  campaigns: {
    root: path(ROOTS_DASHBOARD, '/campaigns'),
    new: path(ROOTS_DASHBOARD, '/campaigns/new'),
    edit: (id: string | number) => path(ROOTS_DASHBOARD, `/campaigns/${id}`),
  },
  documentsIndex: path(ROOTS_DASHBOARD, '/documents'),
  ptcDocument: path(ROOTS_DASHBOARD, '/documents/ptc'),
  myDocument: (type: string, userId?: string | number) =>
    path(ROOTS_DASHBOARD, `/documents/my/${type}${userId ? `?userId=${userId}` : ''}`),
  oldPtcDocument: path(ROOTS_DASHBOARD, '/documents/old/ptc'),
  whsDocument: path(ROOTS_DASHBOARD, '/documents/whs'),
  oldWhsDocument: path(ROOTS_DASHBOARD, '/documents/old/whs'),
  wirDocument: path(ROOTS_DASHBOARD, '/documents/wir'),
  oldWirDocument: path(ROOTS_DASHBOARD, '/documents/old/wir'),
  swmsDocument:path(ROOTS_DASHBOARD, '/documents/swms'),
  hrwaDocument:path(ROOTS_DASHBOARD, '/documents/hrwa'),
  apiKeys:path(ROOTS_DASHBOARD, '/api-keys'),
  hazardousSubstances:path(ROOTS_DASHBOARD, '/documents/hazardousSubstances'),
  termsAndConditions: path(ROOTS_DASHBOARD, '/documents/termsAndConditions'),
  jobsiteSwms:path(ROOTS_DASHBOARD, '/jobsiteSWMS'),
  constructionTypes:path(ROOTS_DASHBOARD, '/jobsiteSWMS/constructionTypes'),
  poolTypes:path(ROOTS_DASHBOARD, '/jobsiteSWMS/poolTypes'),
  docVerification:path(ROOTS_DASHBOARD, '/verification'),
  verifyCards:path(ROOTS_DASHBOARD, '/verification/cards'),
  verifyLicenses:path(ROOTS_DASHBOARD, '/verification/licenses'),
  verifyInsurances:path(ROOTS_DASHBOARD, '/verification/insurances'),
  verifyWorkcovers:path(ROOTS_DASHBOARD, '/verification/workCovers'),
  verifyEwpcards:path(ROOTS_DASHBOARD, '/verification/ewpCards'),
  verifyWorkingheightscards:path(ROOTS_DASHBOARD, '/verification/workingHeightsCards'),
  verifyTesttag:path(ROOTS_DASHBOARD, '/verification/testTag'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    list2: path(ROOTS_DASHBOARD, '/user/list'),
    list3: path(ROOTS_DASHBOARD, '/user/list'),
    yourteam: path(ROOTS_DASHBOARD, '/user/yourteam'),
    documents: path(ROOTS_DASHBOARD, '/user/documents'),
    mycompanies: path(ROOTS_DASHBOARD, '/user/mycompanies'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    jobsites: path(ROOTS_DASHBOARD, '/jobsites'),
    addjobsite: path(ROOTS_DASHBOARD, '/jobsites/add'),
    jobdetails: path(ROOTS_DASHBOARD, '/jobsites'),
    jobdetailssubcontractor: path(ROOTS_DASHBOARD, '/jobsites')
  },
  dash: {
    officeadmin: path(ROOTS_DASHBOARD, '/officeadmin'),
    admin: path(ROOTS_DASHBOARD, '/admin/users'),
    builderDash: path(ROOTS_DASHBOARD, '/dashBuilder'),
    overview: path(ROOTS_DASHBOARD, '/overview'),
    checklist: path(ROOTS_DASHBOARD, '/checklist'),
    onSiteNow: path(ROOTS_DASHBOARD, '/on-site'),
    // The register modules from the navigation blueprint.
    incidents: path(ROOTS_DASHBOARD, '/incidents'),
    actions: path(ROOTS_DASHBOARD, '/actions'),
    equipment: path(ROOTS_DASHBOARD, '/equipment'),
    risks: path(ROOTS_DASHBOARD, '/risks'),
    inspections: path(ROOTS_DASHBOARD, '/inspections'),
    training: path(ROOTS_DASHBOARD, '/training'),
    noticeboard: path(ROOTS_DASHBOARD, '/noticeboard'),
    chemicals: path(ROOTS_DASHBOARD, '/chemicals'),
    tasks: path(ROOTS_DASHBOARD, '/tasks'),
    docRequirements: path(ROOTS_DASHBOARD, '/document-requirements'),
    plans: path(ROOTS_DASHBOARD, '/plans'),
    choosePlan: path(ROOTS_DASHBOARD, '/plans/choose'),
    builder: path(ROOTS_DASHBOARD, '/builder'),
    employee: path(ROOTS_DASHBOARD, '/employee'),
    subcontractor: path(ROOTS_DASHBOARD, '/subcontractor'),
    supervisor: path(ROOTS_DASHBOARD, '/supervisor'),
    storeAdmin: path(ROOTS_DASHBOARD, '/storeAdmin'),
    storeAdminProducts: path(ROOTS_STORE, '/products'),
    storeAdminClaims: path(ROOTS_STORE, '/claims'),
    storeAdminSettings: path(ROOTS_STORE, '/settings'),

  },
  admin: {
    root: path(ROOTS_DASHBOARD, '/admin'),
    overview: path(ROOTS_DASHBOARD, '/admin/overview'),
    jobsites: path(ROOTS_DASHBOARD, '/admin/jobsites'),
    users: path(ROOTS_DASHBOARD, '/admin/users'),
    teams: path(ROOTS_DASHBOARD, '/admin/teams'),
    builderTeams: path(ROOTS_DASHBOARD, '/admin/teams/builder/:builderId'),
    teamMembers: path(ROOTS_DASHBOARD, '/admin/teams/:ownerUserId/members'),
    templates: path(ROOTS_DASHBOARD, '/admin/templates'),
    templateEdit: path(ROOTS_DASHBOARD, '/admin/templates/:slug'),
    businessTypeRequirements: path(ROOTS_DASHBOARD, '/admin/document-templates'),
    subscriptionRequests: path(ROOTS_DASHBOARD, '/admin/subscription-requests')
  }
};

// Mobile / field PWA routes. Public landing is /go (QR scan target);
// confirm screens live under /m/* and require auth.
export const PATH_MOBILE = {
  go: '/go',
  root: ROOTS_MOBILE,
  roster: path(ROOTS_MOBILE, '/roster'),
  siteDocs: path(ROOTS_MOBILE, '/site-docs/:jobsiteId'),
  signOn: path(ROOTS_MOBILE, '/sign-on/:jobsiteId'),
  signOff: path(ROOTS_MOBILE, '/sign-off/:jobsiteId'),
  switchSites: path(ROOTS_MOBILE, '/switch-sites/:jobsiteId'),
  registerAtSite: path(ROOTS_MOBILE, '/register/:jobsiteId'),
  loginAtSite: path(ROOTS_MOBILE, '/login/:jobsiteId'),
  joinSubbie: path(ROOTS_MOBILE, '/join-subbie'),
  acknowledge: path(ROOTS_MOBILE, '/acknowledge/:jobsiteId'),
};

// Build a /m/acknowledge/:jobsiteId URL — used by SignOnConfirm when the
// preflight returns needsAck:true (or when sign-on POST 412s with the same
// hint). Callers don't string-template the path themselves.
export const buildAcknowledgePath = (jobsiteId: number | string) =>
  `${ROOTS_MOBILE}/acknowledge/${jobsiteId}`;

// Helpers so callers don't string-template path params themselves.
export const buildAdminBuilderTeamsPath = (builderId: number | string) =>
  `${ROOTS_DASHBOARD}/admin/teams/builder/${builderId}`;
export const buildAdminTeamMembersPath = (ownerUserId: number | string) =>
  `${ROOTS_DASHBOARD}/admin/teams/${ownerUserId}/members`;

export const PATH_DOCS = '/auth/login';